import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _path;
const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';
function ThumbsUp(_ref) {
  let {
      size: sizeProp,
      title,
      titleId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.873 9.908a1.666 1.666 0 01-.721 2.09 1.498 1.498 0 01-.64 2.051 1.5 1.5 0 01-.666 2c.102.207.154.434.154.664 0 .433-.195 1.166-1.5 1.166h-4.333c-.922.005-1.842-.1-2.739-.314-.204-.043-.42-.088-.658-.133a.333.333 0 01-.27-.327V10.36a.333.333 0 01.144-.275c1.27-.877 2.69-2.877 2.69-4.707a1.334 1.334 0 011.109-1.367c.649-.09 1.48.31 1.872 1.71a5.79 5.79 0 01-.347 2.938.166.166 0 00.158.219h4.207a1.667 1.667 0 011.54 1.029zm-12.568 0a.667.667 0 01.195.47v7.334a.667.667 0 01-.667.667H4.667A.667.667 0 014 17.712V10.38a.667.667 0 01.667-.667h2.166c.177 0 .347.07.472.195zm-.89 6.915a.5.5 0 10-.831-.555.5.5 0 00.832.555z"
  })));
}
ThumbsUp.sizes = sizes;
ThumbsUp.defaultProps = {
  size: sizes.md
};
ThumbsUp.propTypes = {
  size: PropTypes.oneOf([ThumbsUp.sizes.xs, ThumbsUp.sizes.sm, ThumbsUp.sizes.md, ThumbsUp.sizes.lg, ThumbsUp.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default ThumbsUp;